/**
 * Web WebView Implementation
 * React Native WebView replacement for web platform
 */

import React from 'react';
import { View } from 'react-native';

const WebView = ({ source, style, injectedJavaScript, onMessage, ...props }) => {
  const iframeRef = React.useRef(null);
  
  React.useEffect(() => {
    if (injectedJavaScript && iframeRef.current) {
      // Can't inject JavaScript into cross-origin iframes
      // This is a limitation of web platform
      console.warn('WebView: JavaScript injection not supported on web for cross-origin content');
    }
  }, [injectedJavaScript]);
  
  // Handle HTML content
  if (source?.html) {
    const htmlContent = source.html;
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobUrl = URL.createObjectURL(blob);
    
    return (
      <View style={style}>
        <iframe
          ref={iframeRef}
          src={blobUrl}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          {...props}
        />
      </View>
    );
  }
  
  // Handle URL source
  const url = source?.uri || source;
  
  return (
    <View style={style}>
      <iframe
        ref={iframeRef}
        src={url}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        {...props}
      />
    </View>
  );
};

export { WebView };
export default WebView;
